import { type RootContainerProps } from "@client/content/types";
import { globals } from "@client/globals";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, combinedSettingsSelector } from "@client/selectors";
import { type AppState } from "@client/types/AppState";
import Component, { type TwitterComponentProps } from "./component";

const makeMapStateToProps = () => {
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    { name: "tweetsAmount", prop: "numberOfTweets" },
    { name: "twitterID", prop: "twitterId" }
  ]);
  return (state: AppState, props: RootContainerProps): TwitterComponentProps => {
    const settings = settingsSelector(state, props);
    return {
      ...props,
      baseUrl: globals.paths.baseUrl,
      ...settings
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
